import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import './masterclasses.css';

export const MasterclassLayout = ({ children, backTo = '/', backLabel = 'Inicio', admin = false }) => (
  <div className="masterclasses min-h-screen bg-white text-neutral-950">
    <header className="border-b border-neutral-200">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-3 sm:px-8">
        <Button variant="ghost" asChild className="shrink-0">
          <Link to={backTo} data-testid="masterclass-back"><ArrowLeft size={16} />{backLabel}</Link>
        </Button>
        <Link to="/" data-testid="masterclass-brand-link" className="min-w-0">
          <img src="https://customer-assets.emergentagent.com/job_13d67352-1aa7-430c-b46e-966b83d4fc8c/artifacts/kmnn6rz3_proyectoresident.png"
            alt="Proyecto Residente" className="h-16 w-40 object-contain sm:w-52" />
        </Link>
      </div>
    </header>
    <main className="mx-auto max-w-5xl px-4 py-8 sm:px-8 sm:py-12">
      {admin && <p className="mb-3 text-xs font-bold uppercase text-neutral-500" data-testid="masterclass-admin-label">Administración / Contenido clínico</p>}
      {children}
    </main>
  </div>
);

export const MasterclassError = ({ message, onRetry }) => (
  <div role="alert" data-testid="masterclass-error" className="my-6 rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-800">
    <p>{message}</p>
    {onRetry && <Button variant="outline" onClick={onRetry} data-testid="masterclass-retry" className="mt-3">Reintentar</Button>}
  </div>
);